import { Injectable } from '@angular/core';
import { Login, LoginResponse } from '../auth/interfaces/login.interface';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject, BehaviorSubject, lastValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private authStateSubject = new Subject<{authenticated: boolean, role: string}>();
  authState$ = this.authStateSubject.asObservable();

  private authorizationCode: string = "";
  private apiUrl: string = "";
  private isLoggedIn = new BehaviorSubject<boolean>(false);
  currentStatus = this.isLoggedIn.asObservable();
  private userName = new BehaviorSubject<string>("");
  currentUserName = this.userName.asObservable();

  constructor(
    private http: HttpClient
  ) {
    this.apiUrl = environment.apiUrl;
    this.authorizationCode = environment.authorizationCode;
  }

  async iniciarSesion( nuevo: Login ): Promise<LoginResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        'api-key': this.authorizationCode,
        'Content-Type': 'application/json'
      })
    };
    const url = `${ this.apiUrl }/auth/login`;
    const login = {
      username: nuevo.username,
      password: nuevo.password
    };
    const response: LoginResponse = await lastValueFrom(this.http.post<LoginResponse>(url, login, httpOptions ));
    return response;
  }

  changeStatus(status: boolean, userName: string) {
    this.isLoggedIn.next(status);
    this.userName.next(userName);
    const role = localStorage.getItem('rol') || '0';
    this.authStateSubject.next({ authenticated: status, role });
  }

  isAuthenticated(): boolean {
    const isAuth = !!localStorage.getItem('token');
    if (isAuth) {
      const role = localStorage.getItem('rol') || '0';
      this.authStateSubject.next({ authenticated: true, role });
    }
    return isAuth;
  }
}
